<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><span>We live, as we dream—alone.</span></p>
<p class="fm1"><span>—Joseph Conrad,</span></p>
<p class="fm2"><span><i>Heart of Darkness</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?07682c66